// extracted by mini-css-extract-plugin
module.exports = {"topCardItem":"cards_topCardItem__uupW_","plashka":"cards_plashka__VIFXs","title":"cards_title__i_y6W","subtitle":"cards_subtitle__x1sDr"};